module.exports = __webpack_public_path__ + "media/got.7f0921cf.webm";